// client/src/components/PrivateRoute.js
import React, { useContext } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

function PrivateRoute() {
  const { user, loading } = useContext(AuthContext);
  const { lang } = useParams();
  if (loading) return <div role="status" className="p-8 text-center">Caricamento…</div>;
  return user ? <Outlet /> : <Navigate to={`/${lang || 'it'}/login`} replace />;
}

export default PrivateRoute;
